import { KalturaAssetType } from '../../enums';
import { createBookmarkFilter, createOnDemandResponseProfile } from '../../factories';
import { fetchBookmarkList } from '../../services';

export type FetchBookmarksArgs = {
  assetIds: number[];
  assetType: KalturaAssetType;
};

export async function fetchBookmarks({ assetIds, assetType }: FetchBookmarksArgs) {
  const { objects } = await fetchBookmarkList({
    filter: createBookmarkFilter({
      assetIdIn: assetIds.join(','),
      assetTypeEqual: assetType,
    }),
    responseProfile: createOnDemandResponseProfile({
      retrievedProperties: 'id,error',
    }),
  });

  return objects ?? [];
}
